import styled from 'styled-components'
import { Dropdown } from 'react-bootstrap'

export const Container = styled(Dropdown.Header)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0.5rem 0;
`
